import { useTheme } from '@/features/theme/ThemeProvider';
import { classNames } from '@/lib/format';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div role="group" aria-label="Theme" className="theme-toggle">
      <button
        type="button"
        className={classNames('theme-toggle__btn', theme === 'dark' && 'is-active')}
        onClick={() => setTheme('dark')}
        aria-pressed={theme === 'dark'}
      >
        Dark
      </button>
      <button
        type="button"
        className={classNames('theme-toggle__btn', theme === 'light' && 'is-active')}
        onClick={() => setTheme('light')}
        aria-pressed={theme === 'light'}
      >
        Light
      </button>
    </div>
  );
}
